<template>
  <a-layout class="main">
    <a-layout-sider width="200" class="bg-w no-fix-sider">
      <a-menu v-model="defaultSelectedKeys" mode="inline" class="menu-ul">
        <a-menu-item
          v-for="menu in menus"
          :key="menu.value"
          class="content-menu"
          :style="{ 'padding-right': badge && menu.badge ? '55px' : '16px' }"
          @click="changeMenu"
        >
          <span class="name">{{ i18n ? $t(menu.label) : menu.label }}</span>
          <a-badge v-if="badge" class="badge1" :count="menu.badge" />
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <div v-resize="'x'"></div>
    <a-layout-content class="content1">
      <slot name="right" />
    </a-layout-content>
  </a-layout>
</template>

<script>
import { getQueryObject } from '@/utils/index.ts'

export default {
  name: 'SplitContent',
  props: {
    i18n: {
      type: Boolean,
      default: false
    },
    badge: {
      type: Boolean,
      default: false
    },
    menus: {
      type: Array
      // default: [{ badge: '', label: '', value: '' }] ,badge为徽标值,若没有徽标可不传
    },
    isReady: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultSelectedKeys: []
    }
  },
  watch: {
    menus: {
      handler(newValue, oldValue) {
        if (newValue && newValue.length && this.isReady) {
          let query = getQueryObject()
          // console.log('00000000000000000000000000',this.$route)
          /*if (query.hasOwnProperty('type')) {
            console.log(11111111111)
            this.defaultSelectedKeys.push(query.type)
            let current = newValue.find(item => item.value = query.type)
            this.$emit('changeItem', current)
          } else {*/
          // console.log(22222222222)
          this.defaultSelectedKeys.push(newValue[0].value)
          this.$emit('changeItem', newValue[0])
          // }
        }
      },
      immediate: true
    },
    defaultValue: {
      handler(newValue, oldValue) {
        if (newValue && newValue.value) {
          console.log(newValue, 556688)
          this.defaultSelectedKeys.push(newValue.value)
          this.$emit('changeItem', newValue)
        }
      },
      immediate: true
    }
  },
  created() {
    /* console.log('0000000',this.$route)
    let query = getQueryObject()
    if (query.hasOwnProperty('type') && this.menus.length) {
      console.log(3333333333)
      let current = this.menus.find(item => item.value = query.type)
      this.defaultSelectedKeys.push(query.type)
      this.$emit('changeItem', current)
    }*/
  },
  methods: {
    changeMenu(menuItem) {
      let selectedItem = this.menus.find((item) => item.value === menuItem.key)
      this.$emit('changeItem', selectedItem)
    }
  }
}
</script>

<style scoped lang="less">
.main {
  background: #fff;
  height: 100%;

  .bg-w {
    background-color: #fff;
    box-shadow: none !important;
  }
}

.menu-ul {
  padding-top: 12px;
  height: 100%;
  overflow: auto;
  padding-right: 1px;
}

.content-menu {
  position: relative;
  padding-right: 55px;

  span.name {
    font-size: 16px;
    vertical-align: middle;
    min-width: 120px;
    display: inline-block;
  }
}

.badge1 {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.content1 {
  height: 100%;
  background-color: #fff;
}
/deep/.ant-layout-sider-children {
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
